export const enum NpvrSettingsKeys {
  recording_episodes = 'recording_episodes',
  recording_before_time = 'recording_before_time',
  recording_after_time = 'recording_after_time',
  recording_delete_protection = 'recording_delete_protection',
}

export const enum ReminderDeviceSettingKeys {
  reminder_before_time = 'reminder_before_time',
}
